export const errorData = {
  titleFirst: 'Page not found.',
  titleSecond: 'Looks like you got a little turned around.',
  buttonTitle: 'RETURN HOME',
};